import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/pro-regular-svg-icons";
import { appStrings } from "./strings";
import "./TryMDH.css";
import AppText from "./AppText";

const TryMDH: React.FC = () => {
    return (
        // <div className='try-mdh-container'>
        <a className="try-mdh" href={appStrings["mdh-url"]}>
            <div className="try-mdh-logo">
                <img
                    src="https://rkstudio-customer-assets.s3.amazonaws.com/CareEvolution/Images/ParticipantLanding/mdhd_bug.svg"
                    alt=" My Data Helps Designer"
                />
            </div>
            <div className="try-mdh-message">
                <strong>
                    <AppText textKey="try-mdh-message" />
                </strong>
                <span>
                    <AppText textKey="try-mdh-sign-in-text" />
                </span>
            </div>
            <FontAwesomeIcon className="try-mdh-arrow" icon={faAngleRight} />
        </a>
        // </div>
    );
};

export default TryMDH;
